export const SOCIAL_LOGIN_PLATFORMS = {
  GOOGLE: 'GOOGLE',
};
export const ERROR_STATUS_CODE = {
  EMAIL_VERIFIED_ERROR: 'alg_wc_ev_email_verified_error',
  INCORRECT_PASSWORD: 'incorrect_password',
  INVALID_EMAIL: 'invalid_email',
};

export const GOOGLE_MAP_LIBRARIES: any[] = ['places', 'geometry'];

export const SELECTION_COLUMN = 'selection_column';

export const QUERY_MOBILE = '62em';
export const QUERY_SMALL_MOBILE = '25em';

export const PAGE_PATHS = {
  MDQ_1: '/mdq1',
  MDQ_1_1: '/welcome',
  MDQ_1_2: '/how-it-works',
  MDQ_1_3: '/user-details',
  MDQ_1_4: '/age-gender-block',
  MDQ_1_5: '/how-did-you-hear',
  MDQ_1_6: '/bmi-calculation',
  MDQ_1_6A: '/underweight-block',
  MDQ_1_6B: '/healthy-block',
  MDQ_1_7: '/symptoms-check',
  MDQ_1_7NEW: '/program-selection',
  MDQ_1_7A: '/symptoms-block',
  MDQ_1_8: '/great-news',
  MDQ_1_8_GLP: '/great-news-glp',
  MDQ_1_8_PILL: '/great-news-pill',
  MDQ_1_8_CGM: '/great-news-cgm',
  MDQ_1_8_SUPPLEMENTS: '/great-news-supplements',
  MDQ_1_8_NUTRITION: '/great-news-nutrition',
  MDQ_1_9: '/chart',
  MDQ_1_9_NUTRITION: '/nutrition-whats-included',
  MDQ_1_10: '/steps-introduction',
  MDQ_1_10_GLP: '/doctor-consultation-glp',
  MDQ_1_10_PILL: '/doctor-consultation-pill',
  MDQ_1_10_CGM: '/select-cgm-package',
  MDQ_1_10_SAXENDA: '/select-saxenda-package',
  MDQ_1_10_RYBELSUS: '/select-rybelsus-package',
  MDQ_1_10_PANBESY: '/select-panbesy-package',
  MDQ_1_10_NUTRITION: '/select-nutrition-package',
  MDQ_1_10_SUPPLEMENTS: '/pharmacist-consultation',
  MDQ_1_10_DOCTOR: '/doctor-consultation',
  MDQ_1_11_GCM: '/select-cgm-add-on',
  MDQ_1_11_SAXENDA: '/do-you-need-needles',
  MDQ_1_11_NEXT_SAXENDA: '/whats-next-saxenda',
  MDQ_1_11_NEXT_RYBELSUS: '/whats-next-rybelsus',
  MDQ_1_11_NEXT_PANBESY: '/whats-next-panbesy',
  MDQ_1_11_NUTRITION: '/plan-weekly-menu',
  MDQ_1_11: '/appointment-preferences',
  MDQ_1_12: '/package-selection',
  MDQ_1_12_NUTRITION: '/nutrition-delivery-preferences',
  MDQ_1_13_NUTRITION: '/dietician-appointment-preferences',
  // MDQ2
  MDQ_2: '/mdq2',
  MDQ_2_1: '/get-started',
  MDQ_2_2: '/additional-details',
  MDQ_2_3: '/obesity-check',
  MDQ_2_4: '/symptoms-check',
  MDQ_2_5: '/current-lifestyle',
  MDQ_2_6: '/eating-habits',
  MDQ_2_7: '/take-weight-loss-before',
  MDQ_2_8: '/did-medication-work',
  MDQ_2_9: '/medical-history',
  MDQ_2_10: '/thank-you',
  MDQ_2_INVALID: '/invalid',
  // MDQ Renewal
  MDQ_RENEWAL: '/mdq-renewal',
  MDQ_RENEWAL_1: '/get-started',
  MDQ_RENEWAL_2: '/additional-information',
  MDQ_RENEWAL_3: '/did-medication-work',
  MDQ_RENEWAL_4: '/symptoms-check',
  MDQ_RENEWAL_5: '/whats-next',
  MDQ_RENEWAL_INVALID: '/invalid',
};

const mdq1Pages = {
  MDQ1_HOME: `${PAGE_PATHS.MDQ_1}`,
  MDQ1_WELCOME: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_1}`,
  MDQ1_HOW_IT_WORKS: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_2}`,
  MDQ1_USER_DETAILS: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_3}`,
  MDQ1_AGE_GENDER_BLOCK: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_4}`,
  MDQ1_HOW_DID_YOU_HEAR: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_5}`,
  MDQ1_BMI_CALCULATION: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_6}`,
  MDQ1_UNDERWEIGHT_BLOCK: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_6A}`,
  MDQ1_HEALTHY_BLOCK: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_6B}`,
  MDQ1_PROGRAM_SELECTION: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_7NEW}`,
  MDQ1_SYMPTOMS_CHECK: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_7}`,
  MDQ1_SYMPTOMS_BLOCK: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_7A}`,
  MDQ1_GREAT_NEWS: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_8}`,
  MDQ1_GREAT_NEWS_GLP: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_8_GLP}`,
  MDQ1_GREAT_NEWS_PILL: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_8_PILL}`,
  MDQ1_GREAT_NEWS_CGM: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_8_CGM}`,
  MDQ1_GREAT_NEWS_SUPPLEMENTS: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_8_SUPPLEMENTS}`,
  MDQ1_NUTRITION_HOW_IT_WORKS: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_8_NUTRITION}`,
  MDQ1_CHART: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_9}`,
  MDQ1_NUTRITION_WHATS_INCLUDED: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_9_NUTRITION}`,
  MDQ1_STEPS_INTRODUCTION: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10}`,
  MDQ1_DOCTOR_CONSULTATION: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_DOCTOR}`,
  MDQ1_DOCTOR_CONSULTATION_GLP: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_GLP}`,
  MDQ1_DOCTOR_CONSULTATION_PILL: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_PILL}`,
  MDQ1_PHARMACIST_CONSULTATION: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_SUPPLEMENTS}`,
  MDQ1_SELECT_CGM_PACKAGE: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_CGM}`,
  MDQ1_SELECT_SAXENDA_PACKAGE: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_SAXENDA}`,
  MDQ1_SELECT_RYBELSUS_PACKAGE: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_RYBELSUS}`,
  MDQ1_SELECT_PANBESY_PACKAGE: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_PANBESY}`,
  MDQ1_SELECT_NUTRITION_PACKAGE: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_10_NUTRITION}`,
  MDQ1_SELECT_CGM_ADD_ON: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11_GCM}`,
  MDQ1_DO_YOU_NEED_NEEDLES: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11_SAXENDA}`,
  MDQ1_WHATS_NEXT_SAXENDA: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11_NEXT_SAXENDA}`,
  MDQ1_WHATS_NEXT_RYBELSUS: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11_NEXT_RYBELSUS}`,
  MDQ1_WHATS_NEXT_PANBESY: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11_NEXT_PANBESY}`,
  MDQ1_PLAN_WEEKLY_MENU: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11_NUTRITION}`,
  MDQ1_APPOINTMENT_PREFERENCES: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_11}`,
  MDQ1_PACKAGE_SELECTION: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_12}`,
  MDQ1_NUTRITION_DELIVERY_PREFERENCES: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_12_NUTRITION}`,
  MDQ1_DIETICIAN_APPOINTMENT_PREFERENCES: `${PAGE_PATHS.MDQ_1}${PAGE_PATHS.MDQ_1_13_NUTRITION}`,
};

const mdq2Pages = {
  MDQ2_HOME: `${PAGE_PATHS.MDQ_2}`,
  MDQ2_GET_STARTED: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_1}`,
  MDQ2_ADDITIONAL_DETAILS: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_2}`,
  MDQ2_OBESITY_CHECK: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_3}`,
  MDQ2_SYMPTOMS_CHECK: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_4}`,
  MDQ2_CURRENT_LIFESTYLE: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_5}`,
  MDQ2_EATING_HABITS: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_6}`,
  MDQ2_TAKE_WEIGHT_LOSS_BEFORE: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_7}`,
  MDQ2_DID_MEDICATION_WORK: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_8}`,
  MDQ2_MEDICAL_HISTORY: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_9}`,
  MDQ2_THANK_YOU: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_10}`,
  MDQ2_INVALID: `${PAGE_PATHS.MDQ_2}${PAGE_PATHS.MDQ_2_INVALID}`,
};

const mdqRenewalPages = {
  MDQ_RENEWAL_HOME: `${PAGE_PATHS.MDQ_RENEWAL}`,
  MDQ_RENEWAL_GET_STARTED: `${PAGE_PATHS.MDQ_RENEWAL}${PAGE_PATHS.MDQ_RENEWAL_1}`,
  MDQ_RENEWAL_ADDITIONAL_INFORMATION: `${PAGE_PATHS.MDQ_RENEWAL}${PAGE_PATHS.MDQ_RENEWAL_2}`,
  MDQ_RENEWAL_DID_MEDICATION_WORK: `${PAGE_PATHS.MDQ_RENEWAL}${PAGE_PATHS.MDQ_RENEWAL_3}`,
  MDQ_RENEWAL_SYMPTOMS_CHECK: `${PAGE_PATHS.MDQ_RENEWAL}${PAGE_PATHS.MDQ_RENEWAL_4}`,
  MDQ_RENEWAL_WHATS_NEXT: `${PAGE_PATHS.MDQ_RENEWAL}${PAGE_PATHS.MDQ_RENEWAL_5}`,
  MDQ_RENEWAL_INVALID: `${PAGE_PATHS.MDQ_RENEWAL}${PAGE_PATHS.MDQ_RENEWAL_INVALID}`,
};

export const PAGE_URLS = {
  ...mdq1Pages,
  ...mdq2Pages,
  ...mdqRenewalPages,
};

export const URL_FILTER_KEY = 'fh_';

export const BUILD_FAILED_TIMES = 1; // build failed times counter
